module.exports = __webpack_public_path__ + "img/logo.804c98f2.png";